export const baoCao = {
  invalid: 'Invalid report',
  moiQuanTam: 'Focus',
  loaiBaoCao: 'Report type',
  thoiGian: 'Period',
  empty: 'No report data',
  chartTitle: 'Chart',
  chartEmpty: 'No numbers to chart',
  hideChart: 'Hide chart',
  showChart: 'Show chart',
  giaiThich: {
    nut: 'How it works',
    tieuDe: 'How the figures are calculated',
    tenKhac: 'List view: {ten}',
    dong: 'Close',
  },
  range: 'From {tu} to {den}',
  dateRangePlaceholder: 'Choose date range',
  fromDate: 'From',
  toDate: 'To',
  maGiaoDich: 'Transaction code',
  maHangHoa: 'Product code',
  tenHangHoa: 'Product name',
  filter: {
    searchPlaceholder: 'Search document, product code/name, customer',
    textDetailTitle: 'Detail filters',
  },
  aria: {
    columnPicker: 'Adjust columns',
  },
  reports: {
    tongHop: 'Overview report',
    doanhThuLn: 'Revenue, profit',
    tonKho: 'Inventory report',
    topSale: 'Top sellers',
    topMua: 'Top buyers',
  },
  tongCong: 'Grand total',
  loiTai: 'Could not load report: {msg}',
  concernGroups: {
    tongHop: 'Summary',
    soSanhKy: 'Period comparison',
    thangChiNhanh: 'Month × branch',
    margin: 'Margin & profit',
  },
  concernsShort: {
    khach: 'By customer',
    sanPham: 'By product',
    nhom: 'By product group',
    khachSp: 'By customer + product',
    mgKhach: 'Sales rep + customer',
    mgNhom: 'KPI group + sales rep',
    lnThang: 'Monthly profit %',
  },
  bangChiTiet: 'Detail table',
  hienThi: { title: 'Display', PIVOT: 'Pivot', DS: 'List' },
  soDong: '{n} rows',
  truncated: 'Showing the first 2,000 rows. Narrow the date range or filters to see the rest.',
  concerns: {
    banHang: 'Sales',
    thuChi: 'Cash in/out',
    hangHoa: 'Products',
    tongHop: 'Summary',
    thoiGian: 'Time',
    loiNhuan: 'Profit',
    giamGiaHd: 'Invoice discount',
    traHang: 'Returns',
    nhanVien: 'Staff',
    chiNhanh: 'Branch',
    giaoDich: 'Transactions',
    giaTriKho: 'Stock value',
    xuatNhapTon: 'In/out stock',
    xuatHuy: 'Write-off',
    congNo: 'Receivables',
    nhapHang: 'Purchases',
    chiTietHd: 'Invoice lines',
    soSanhKy: 'Period comparison',
    chiTietNgan: 'Detail',
    soSanhNgan: 'Compare',
    thangNhom: 'Month + category',
    nvkdNhom: 'Salesperson + month + category',
    nvkdKhach: 'Salesperson + month + customer',
    khachThang: 'Customer + month',
    tonNgay: 'Daily stock',
    tonKy: 'Stock by period',
    tonGiaoDich: 'Stock movements',
    tonGoiY: 'Non-moving + reorder',
    tonGoiYGop: 'Reorder (all branches)',
    topSanPham: 'By product',
    topToanBo: 'Whole scope',
    topTungMang: 'Within each segment',
    topTungChiNhanh: 'Within each branch',
    topChiNhanh: 'By product + branch',
    ssKhach: 'Period comparison by customer',
    ssSanPham: 'Period comparison by product',
    ssNhom: 'Period comparison by product group',
    pvSanPham: 'Month × branch by product',
    pvKhach: 'Month × branch by customer',
    pvKhachSp: 'Month × branch by customer + product',
    mgKhach: 'Margin by sales rep + customer',
    mgNhom: 'Margin by KPI group + sales rep',
    lnThang: 'Monthly profit % by KPI group + branch',
  },
  kpi: {
    dt: 'Net revenue',
    ln: 'Profit',
    margin: '% Margin',
    sl: 'Quantity',
    so: 'vs',
    thamChieu: 'reference',
    diemPct: 'pp',
  },
  charts: {
    trend: 'Monthly trend',
    top: 'Top {n} by {metric}',
    coCau: '{metric} by {dim}',
    theoKy: 'Revenue & profit by period',
    topKy: 'Top {n} revenue {nhan} vs other periods',
    khac: 'Other',
  },
  soSanh: {
    kySection: 'Comparison period',
    kieuKy: 'Period type',
    luyKeNgan: 'YTD',
    kieuKyOptions: {
      THANG: 'Month',
      QUY: 'Quarter',
      NAM: 'Year',
      N_THANG: 'Multiple months',
      LUY_KE: 'Year to date',
      TUAN: 'Week',
      TUY_CHON: 'Custom',
    },
    denThang: 'Up to month',
    nam: 'Year',
    quy: 'Quarter',
    thang: 'Month',
    tuThang: 'From month',
    tuNgan: 'From',
    denNgan: 'To',
    soThang: 'Number of months',
    soThangValue: '{n} months',
    tuan: 'Week',
    tuyChon: {
      loai: { THANG: 'Month', QUY: 'Quarter', NAM: 'Year', TUAN: 'Week', NGAY: 'Date range' },
      loaiNgan: { THANG: 'Month', QUY: 'Qtr', NAM: 'Year', TUAN: 'Week', NGAY: 'Dates' },
      kyGoc: 'Base',
      kyN: 'Period {n}',
      themKy: 'Add period',
      xoaKy: 'Remove period',
      tuanShort: 'Week {n}',
    },
    chiNhanhSection: 'Branch',
    tachChiNhanh: 'Split by branch',
  },
  phamVi: {
    duAnSection: 'Project',
    duAnMacDinh: 'Current project',
    duAnEmpty: 'No projects',
    chonTatCa: 'Select all',
    boChonTatCa: 'Deselect all',
    chonNhanh: 'Quick scope',
    toanHeThong: 'Whole system',
    mangDangDung: 'Current segment',
    chiNhanhDangDung: 'Current branch',
    section: 'Scope',
    heThongNgan: 'System',
    mangNgan: 'Segment',
    chiNhanhNgan: 'Branch',
  },
  topSale: {
    section: 'Top options',
    xepHang: 'Ranking',
    xepHangNgan: { TOAN_BO: 'Whole scope', TUNG_MANG: 'By segment', TUNG_CHI_NHANH: 'By branch' },
    tieuChi: 'Rank by',
    tieuChiOptions: { DOANH_THU: 'Revenue', SO_LUONG: 'Quantity', LOI_NHUAN: 'Profit' },
    soTop: 'Show top',
    soTopValue: 'Top {n}',
    kieuXep: 'Method',
    kieuXepOptions: { KY: 'Whole period', THANG: 'Each month' },
    kieuXepHint: {
      KY: 'Sum the whole date range, then rank.',
      THANG: 'Rank each month separately and count the months a product is in the top.',
    },
    tomTat: {
      top: 'Top {n} by {tieuChi}',
      phan: {
        TOAN_BO: 'Whole scope combined',
        TUNG_MANG: 'Ranked within each segment',
        TUNG_CHI_NHANH: 'Ranked within each branch',
      },
      soMang: '{n} segments',
      soChiNhanh: '{n} branches',
      tatCaChiNhanh: 'all branches',
    },
    kpi: {
      soSp: 'Top products',
      soKh: 'Top customers',
      soHd: 'Invoices',
      sl: 'Net quantity',
      dtTruocTra: 'Revenue',
      traHang: 'Returns',
    },
  },
  tonKho: {
    kpi: {
      soMa: 'Items',
      soPhieu: 'Vouchers',
      tonDau: 'Opening stock',
      nhap: 'Stock in',
      xuat: 'Stock out',
      tonCuoi: 'Closing stock',
      bienDong: 'Stock change',
      chenhLech: 'In − out',
      doanhSo: 'Sales in period',
      gp: 'Gross profit',
      nonmoving: 'Non-moving items',
      tonCao: 'Overstocked items',
      canDat: 'Items to reorder (30d)',
      choGiao: 'Pending delivery',
    },
    sub: {
      sl: 'Qty {v}',
      slBan: 'Sold {v}',
      slDat: 'Suggested {v}',
      fm: 'FM {v}',
      giaTri: 'Value {v}',
    },
  },
  luu: {
    nutLuu: 'Save',
    nutDaLuu: 'Saved',
    tieuDe: 'Save report',
    suaTieuDe: 'Edit saved report',
    trangTieuDe: 'Saved reports',
    luu: 'Save',
    huy: 'Cancel',
    sua: 'Edit',
    xoa: 'Delete',
    boGhim: 'Unpin',
    dangLuu: 'Saving…',
    dangChup: 'Capturing data…',
    daLuu: 'Saved "{ten}"',
    daXoa: 'Saved report deleted',
    xemDanhSach: 'View list',
    xemTatCa: 'View all saved reports',
    chuaCo: 'No saved reports yet',
    moTaPhamVi: 'Period: {ky}',
    soBang: '{n} data tables',
    ghimMoTa: 'Pinned snapshots do not expire after 180 days.',
    taiExcel: 'Download Excel',
    chayLai: 'Re-run with fresh data',
    tatCaThoiGian: 'All time',
    chiBanChup: 'Only available for snapshot reports',
    khongCoQuyenSua: 'You do not have permission to edit this report',
    moBanChup: 'Open snapshot',
    moBoLoc: 'Open with saved filters',
    daHetHan: 'Expired',
    khongHetHan: 'Never',
    biCat: 'Data was truncated when saved',
    xuLyTrong: 'Took {s} s',
    chiCuaToi: 'Only my reports',
    cuaToi: 'Mine',
    tatCaLoai: 'All reports',
    tatCaKieu: 'All',
    timKiem: 'Search',
    timKiemPlaceholder: 'Search by report name, note',
    xacNhanXoa: 'Delete saved report "{ten}"? Its snapshot data will also be deleted.',
    boLocBiKhoa: 'Viewing a snapshot — click "Re-run with fresh data" to change filters',
    khongCoTrongBanChup: 'The snapshot has no data for this layout. Click "Re-run with fresh data" to query again.',
    kieu: {
      BAN_CHUP: 'Data snapshot',
      BO_LOC: 'Filters only',
    },
    kieuMoTa: {
      BAN_CHUP: 'Keep the figures as of now to review and export to Excel exactly as saved.',
      BO_LOC: 'Keep only the filters; reopening runs on the latest data.',
    },
    chiaSe: {
      CA_NHAN: 'Only me',
      DU_AN: 'Everyone in the project',
    },
    truong: {
      ten: 'Name',
      ghiChu: 'Note',
      kieu: 'Save type',
      chiaSe: 'Sharing',
      ghim: 'Pin',
      loaiBaoCao: 'Report',
      khoangNgay: 'Date range',
      thoiGianTruyVan: 'Queried at',
      soDong: 'Rows',
      nguoiLuu: 'Saved by',
      hetHan: 'Expires',
      boLoc: 'Filters',
      tenBaoCao: 'Report name',
      tuNgay: 'From',
      denNgay: 'To',
      thoiGianXuLy: 'Processing time',
      kichThuoc: 'Size',
      ngayTao: 'Saved at',
      trangThai: 'Status',
      thaoTac: 'Actions',
    },
    soGiay: '{s} s',
    conHan: 'Active',
    anHienCot: 'Show/hide columns',
    ngan: {
      reports: {
        doanhThuLn: 'Rev-Profit',
        tonKho: 'Inventory',
        topSale: 'Top sale',
        topMua: 'Top buyers',
      },
      concerns: {
        chiTietHd: 'Detail',
        soSanhKy: 'Compare',
        giamGiaHd: 'Discount',
        xuatNhapTon: 'Stock movement',
        tonNgay: 'Daily',
        tonKy: 'By period',
        tonGiaoDich: 'In/out',
        tonGoiY: 'Reorder',
        topTungMang: 'By segment',
        topTungChiNhanh: 'By branch',
      },
    },
    banner: {
      dangTai: 'Loading snapshot…',
      loi: 'Could not open snapshot: {msg}',
      dangXem: 'Viewing snapshot "{ten}"',
      truyVanLuc: 'Figures as of {tg}',
      nguoiLuu: 'Saved by: {ten}',
    },
    excel: {
      sheetThongTin: 'Info',
      pivot: 'pivot',
    },
  },
  pivot: {
    title: 'Pivot table',
    titleDs: 'List',
    mauLabel: 'Templates:',
    tuyChinh: 'Custom',
    moCap: 'Expand to level',
    thuGon: 'Collapse',
    truncated: 'Too much data, only the first {n} rows were aggregated. Narrow the dates, scope or fields.',
    nhieuDong: 'Showing the first {n} rows — collapse some groups to see the rest.',
    nhieuDongDs: 'Showing the first {n} rows — narrow the filters to see the rest.',
    soNhom: '{n} level-1 groups',
    chonGiaTri: 'Pick at least one measure in Measures.',
    sapTheoNhan: 'Click to sort by label',
    sapTheoCot: 'Click to sort by this column (desc → asc → off)',
    thang: 'Month {n}',
    quy: 'Q{n}',
    tongCua: '{label} total',
    timTruong: 'Search fields / measures',
    tongPhuCot: 'Show subtotal column for each column group',
    giaTriTruoc: 'Group columns by metric',
    giaTriTruocMoTa: 'Column header: metric on top, periods below (metric › period)',
    nhomTheo: 'Group by',
    dongTheoCap: 'Rows by level',
    giaTriSection: 'Values',
    chiaCot: 'Split columns by',
    chiSoNut: 'Measures',
    soChiSo: '{n} measures',
    khongChon: 'None',
    sapXep: 'Sort',
    sapMacDinh: 'Default',
    sapNhanTang: 'By name A → Z',
    sapNhanGiam: 'By name Z → A',
    giamDan: 'descending',
    tangDan: 'ascending',
    motCot: 'one column',
    themLoc: 'Add filter',
    locTatCa: 'All',
    locRong: 'None selected',
    locSo: '{n}/{m}',
    lenTren: 'Move up',
    xuongDuoi: 'Move down',
    stt: 'No.',
    boMuc: 'Remove',
    themCap: 'Add row level…',
    themChiSo: 'Add value…',
    themTatCa: 'Add all',
    boHet: 'Clear all',
    khongTimThay: 'No match',
    chuaChonCap: 'No level selected — only the total row is shown.',
    chuaChonChiSo: 'No value selected.',
    locGiaTri: {
      title: 'Filter values',
      tim: 'Search values',
      chonTatCa: 'Select all',
      boChon: 'Deselect all',
      conNua: '{n} more values — type to search',
      dangChon: '{n}/{m} selected',
      xoaLoc: 'Clear filter',
      xong: 'Done',
    },
    mau: {
      hoaDon: 'Day + salesperson (current month)',
      tongHop: 'Summary by year',
      thangNhom: 'Month + product group',
      nvkdNhom: 'Sales rep + month + group',
      nvkdKhach: 'Sales rep + month + customer',
      khachThang: 'Customer × month (across)',
      thangChiNhanh: 'Month × branch',
      marginKhach: 'Margin by rep + customer',
      ssNhomHang: 'Product group › item',
      ssNvkdNhom: 'Sales rep › group › item',
      ssNvkdKhach: 'Sales rep › customer',
      ssKhachHang: 'Customer › item',
      tonNgay: 'Daily stock',
      tonKy: 'Stock by branch',
      tonThang: 'Month-end stock',
      tonGiaTri: 'Stock value',
      gdDoc: 'In/out by day',
      gdLoaiPhieu: 'By voucher type (columns)',
      gdHuong: 'In / out × voucher type',
      goiYNhom: 'All items',
      chiNonmoving: 'Nonmoving only',
      goiYChiNhanh: 'By branch',
    },
    truong: {
      nam: 'Year',
      quy: 'Quarter',
      thang: 'Month',
      ngay: 'Day',
      thangNam: 'Month/Year',
      ngayDayDu: 'Date',
      mang: 'Project',
      chiNhanh: 'Branch',
      nvkd: 'Sales rep',
      nhom1: 'Group level 1',
      nhom2: 'Group level 2',
      nhom3: 'Group level 3',
      nhom: 'Group (3 levels)',
      hang: 'Item code - name',
      khach: 'Customer code - name',
      cuMoi: 'New / returning customer',
      maHd: 'Invoice no.',
      tinh: 'Province / city',
      phuong: 'Ward / commune',
      kySs: 'Period',
      huong: 'In / Out',
      loai: 'Voucher type',
      maPhieu: 'Voucher no.',
      nonmoving: 'Nonmoving',
      tinhTrang: 'Status',
      noteTop: 'Top sale note',
      dangKd: 'Active',
    },
    chiSo: {
      sl: 'Qty',
      slTbThang: 'Avg qty/month',
      doanhThu: 'Revenue',
      giamGia: 'Discount',
      thuKhac: 'Other charges',
      vat: 'VAT',
      traHang: 'Returns',
      dtThuan: 'Net revenue',
      giaVon: 'COGS',
      loiNhuan: 'Profit',
      lnTrenVon: '% Profit/cost (markup)',
      margin: '% Profit/revenue (margin)',
      tyTrong: '% Revenue share',
      xepHang: 'Revenue rank',
      soKg: 'Kg',
      soKhoi: 'Volume',
      tonDau: 'Opening qty',
      gtDau: 'Opening value',
      kgDau: 'Opening kg',
      khoiDau: 'Opening volume',
      slNhap: 'Qty in',
      gtNhap: 'Value in',
      slXuat: 'Qty out',
      gtXuat: 'Value out',
      tonCuoi: 'Closing qty',
      gtCuoi: 'Closing value',
      kgCuoi: 'Closing kg',
      khoiCuoi: 'Closing volume',
      slPs: 'Qty moved',
      gtPs: 'Value moved',
      tonBq: 'Avg stock',
      vongQuay: 'Turnover',
      roii: 'ROII',
      slBan: 'Qty sold',
      doanhSo: 'Sales',
      gp: 'Gross profit',
      fm: '% FM',
      slYoy: 'Qty LY',
      dtYoy: 'Revenue LY',
      slCho: 'Qty pending',
      gtCho: 'Value pending',
      goiY30: 'Suggest 30 days',
      goiY60: 'Suggest 60 days',
    },
    giaTriTruong: {
      moi: 'New',
      cu: 'Returning',
      nhap: 'In',
      xuat: 'Out',
      nonmoving: 'Nonmoving',
      binhThuong: 'Normal',
      tonCao: 'High stock',
      nonmovingTonCao: 'Nonmoving, high stock',
      topSale: 'Top sale',
      khac: 'Other',
      dangKd: 'Active',
      ngungKd: 'Discontinued',
      NHAP_MUA: 'Purchase in',
      NHAP_CHUYEN: 'Transfer in',
      NHAP_TRA_HANG: 'Customer return in',
      NHAP_DIEU_CHINH: 'Adjustment in',
      NHAP_KHAC: 'Other in',
      XUAT_BAN: 'Sales out',
      XUAT_CHUYEN: 'Transfer out',
      XUAT_TRA_NCC: 'Return to supplier',
      XUAT_HUY: 'Write-off',
      XUAT_NOI_BO: 'Internal use',
      XUAT_DIEU_CHINH: 'Adjustment out',
      XUAT_KHAC: 'Other out',
      KIEM_KE: 'Stock take',
      kiemKe: 'Stock take',
    },
  },
}
